<template>
<div class="row">
    <div class="col-sm-6">
        <h2><i class="fa fa-fw fa-lg fa-file-text-o"></i> Rechnung</h2>
        <p></p>
        <div id="operator-company" class="v-form-partial">
            <div class="v-form">
                <fieldset>
                    <section>
                        <label class="label">{{ $label('operator.invoice_headline_label') }}</label>
                        <label class="input">
                            <input v-model="billingSetting.invoice_headline"
                                v-on:keyup.enter="requestModelChange"
                                :class="{ 'text-input-error': hasError('invoice_headline') }"
                                :disabled="updating"
                                :placeholder="$label('operator.invoice_headline_label')"
                                type="text"
                            />
                        </label>
                        <p class="text-danger">{{ getError('invoice_headline') }}</p>
                    </section>

                    <div class="row">
                        <section class="col col-6">
                            <section>
                                <label class="label">{{ $label('operator.invoice_payment_term_label') }}</label>
                                <label class="input">
                                    <input v-model="billingSetting.invoice_payment_term_days"
                                        v-on:keyup.enter="requestModelChange"
                                        :class="{ 'text-input-error': hasError('invoice_payment_term_days') }"
                                        :disabled="updating"
                                        :placeholder="$label('operator.invoice_payment_term_placeholder')"
                                        type="text"
                                    />
                                </label>
                                <p class="text-danger">{{ getError('invoice_payment_term_days') }}</p>
                            </section>
                        </section>

                        <section class="col col-6">
                            <label class="label">&nbsp;</label>
                            <label class="checkbox">
                                <input v-model="billingSetting.invoice_print_payment_term" type="checkbox" :disabled="updating"><i></i> {{ $label('operator.invoice_print_payment_term') }}
                            </label>
                        </section>
                    </div>
                    <div class="row">
                        <section class="col col-6">
                            <label class="label">&nbsp;</label>
                            <label class="checkbox">
                                <input v-model="billingSetting.invoice_pseudo_vat_free" type="checkbox" :disabled="updating"><i></i> Unecht Steuerbefreit
                            </label>
                            <div class="note">Hinweis wird auf Rechnung angedruckt</div>
                        </section>
                        <section class="col col-6">
                            <div class="alert alert-info">
                                <i class="fa fa-fw fa-lg fa-info-circle"></i> Wir sind gemäß § 6 Abs. 1 Z. 14 UStG unecht steuerbefreit und daher nicht berechtigt, eine
                                Mehrwertsteuer gesondert in Rechnung zu stellen.
                            </div>
                        </section>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
    <div class="col-sm-6">
        <h2><i class="fa fa-fw fa-lg fa-text-width"></i> Zusatztext</h2>
        <p></p>
        <div class="v-form-partial">
            <div class="v-form">
                <fieldset>
                    <section>
                        <label class="label">Wird am unteren Ende der Rechnung angedruckt</label>
                        <label class="textarea">
                            <textarea v-model="billingSetting.invoice_additional_text" :class="{ 'text-input-error': hasError('invoice_additional_text') }" :disabled="updating" rows="10"></textarea>
                        </label>
                        <p class="text-danger">{{ getError('invoice_additional_text') }}</p>
                    </section>
                </fieldset>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors.js';
import ModelActionsMixin from '@/mixins/ModelActions.js';

export default {
    props: ['operatorId', 'updating'],

    mixins: [FormErrorsMixin, ModelActionsMixin],

    data() {
        return {
            validatedInputs: [
                'invoice_headline', 'invoice_payment_term_days',
                'invoice_print_payment_term', 'invoice_pseudo_vat_free',
                'invoice_additional_text',
            ],
            errors: [],
            parentView: 'operatorInvoiceSettings',
            modelData: 'billingSetting',
            alwaysUpdate: true,
            billingSetting: {
                id: null,
                invoice_headline: null,
                invoice_payment_term_days: null,
                invoice_print_payment_term: null,
                invoice_pseudo_vat_free: null,
                invoice_additional_text: null,
            }
        }
    },

    mounted() {
        this.initializeBillingSetting();
    },

    methods: {
        initializeBillingSetting() {
            if (!this.operatorId) {
                return;
            }

            this.resetModel();
            this.getBillingSetting();
        },

        getBillingSetting(successCallback) {
            let endpoint = this.$partnerEndpoint('operators/' + this.operatorId + '/billing-setting');
            Api().get(endpoint)
                .then((response) => {
                    this.billingSetting = response.data.data;
                    this.emitModelLoadedEvent();
                })
                .catch((error) => {
                    this.emitModelLoadedEvent(false);
                });
        },

        updateModel() {
            this.resetErrors();
            let endpoint = this.$partnerEndpoint('operators/' + this.operatorId + '/billing-setting');

            Api().put(endpoint, this.billingSetting)
                .then((response) => {
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.emitModelUpdatedEvent(false);
                    this.storeErrors(error.response.data.errors);
                });
        },
    },

    watch: {
        operatorId(operatorId) {
            this.initializeBillingSetting();
        },
    }
}
</script>
